import React, { useState } from "react";
import realms from "../realms";
import "./SearchBar.css";

function SearchBar({ onSearch, loading, onSuccess }) {
  const [name, setName] = useState("");
  const [realm, setRealm] = useState("Icecrown");

  // Helper to normalize character name: first letter uppercase, rest lowercase
  const normalizeName = (str) => {
    const s = (str || '').trim();
    if (!s) return '';
    return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name.trim()) {
      alert("Please enter a character name.");
      return;
    }
    const normalized = normalizeName(name);
    try {
      const result = onSearch(normalized, realm);
      if (result && typeof result.then === 'function') {
        await result;
      }
      setName('');
    } catch (err) {
      // Search failed; keep the name in the input for correction
      // Let parent handle error messaging
    }
  };

  return (
  <form className="search-bar" onSubmit={handleSubmit}>
      <input
        type="text"
        placeholder="Character name..."
        value={name}
        onChange={e => setName(normalizeName(e.target.value))}
        disabled={loading}
        className="search-input"
      />
      <select
        value={realm}
        onChange={e => setRealm(e.target.value)}
        className="realm-select"
        disabled={loading}
      >
        {realms.map(r => (
          <option key={r} value={r}>{r}</option>
        ))}
      </select>
      <button type="submit" className="search-btn" disabled={loading}>
        {loading ? "Searching..." : "Search"}
      </button>
    </form>
  );
}

export default SearchBar;
